export default "/assets/images/critter-cuddler-small.ce4de3878f1b3825.webp";